import React from 'react';
import { Table } from 'reactstrap';
import Presenter from '../../../presenter.js';
import RequestProperties from '../../request.props.js';

// Component
import AssetRow from './row/AssetRow.js';
import {ButtonValidation} from '../../../../../component/Button.js';
import windowStop from '../../../../../utils/windowStop.js';
import lang from 'config/language' 
import PopoverHelper from 'utils/PopoverHelper';

export default class AssetList extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			RowElement	: null,
      nextURL 		: null,
      loadingLoadMore : true,
      isLoading		: 'loading',
      
      // Modal Detail
      SelectedItem  : '',
      modalDetail 	: false,
		}
		this.RowData 					= null;
    this.loadData 				= this.loadData.bind(this);
    this.openModalDetail 	= this.openModalDetail.bind(this);
    this.closeModalDetail = this.closeModalDetail.bind(this);
//     console.log(props);
	}

  openModalDetail(data) {
    this.setState({
      modalDetail: true,
      SelectedItem: data
    })
  }

  closeModalDetail() {
    this.setState({modalDetail: false})
  }

	generateRow(row) {
		var element = row.map((val, index) => {
			return (<AssetRow RowData={val} key={index} history={this.props.history} openModalDetail={this.openModalDetail}></AssetRow>)
		})
		return element;
	}

	loadData(action) {
    this.setState({loadingLoadMore : true})  

    Presenter.ReadSiteAsset(
      RequestProperties.ReadPropsSiteAsset(
        action,
        this,
        this.onReadSuccess,
        this.onReadFailed,
        this.props.selectedItem.Alias
      )
    );
  }
  
  onReadSuccess(params, response) {
  	let obj = {};
  	if(params.action === 'Read'){
  		this.self.RowData = response.data.results;
  		obj = {
      	RowElement: this.self.generateRow(response.data.results),
  		}
  	}else{
  		this.self.RowData = [...this.self.RowData, ...response.data.results]
  		obj = {
      	RowElement: this.self.generateRow(this.self.RowData),
  		}
  	}

  	obj = {
  		...obj,
      nextURL 				: response.data.next,
  		isLoading				: 'success',
  		loadingLoadMore : false,
  	}
    this.self.setState(obj)
  }

  onReadFailed(params, response) {
    this.self.setState({
      isLoading: 'failed'      
    })
    console.log("Read failed");
  }

  renderLoadMoreButton(){
		if(this.state.nextURL !== null){
			return(
				<ButtonValidation is_process={this.state.loadingLoadMore} onClick={()=>this.loadData('Next')}>Load More</ButtonValidation>
			)
		}else{
			return null;
		}
  }

	componentDidMount() {
		this.loadData('Read');
	}

  componentWillUnmount() {
    windowStop()
  }

	render() {
    const isLoading = this.state.isLoading;
    let RowElement = this.state.RowElement;
    let Element;

    if(isLoading === 'loading') {
      Element = <tr><td className="table-loading-inside" colSpan="100%">Loading data . . .</td></tr>;
    } else if(isLoading === 'success') {
        if(RowElement !== null && RowElement.length > 0) {
          Element = RowElement;
        }else {
          Element = <tr><td className="table-not-found" colSpan="100%"><span className="icon-drawer"></span>&nbsp;data empty</td></tr>;
        }
    } else if(isLoading === 'failed') {
      Element = <tr><td className="table-loading-inside" colSpan="100%">Failed load data</td></tr>;
    } else {
      Element = <tr><td className="table-loading-inside" colSpan="100%">Something went wrong</td></tr>;
    }

		return (
			<div>
				<div className="list-separator"><div className="item-inner"><strong>Asset List</strong></div></div>
				<Table className="table table-striped table-responsive m-top-15">
					<thead>
						<tr>
							<th>Asset/Tool</th>
							<th>Location</th>
							<th>Type</th>
							<th>Status<PopoverHelper
                    id='job_siteinformation_status' 
                    content={lang.job_siteinformation.status}
                  /></th>
              <th>Assigned</th>
							<th className="text-center">Maintenance<PopoverHelper
                    id='job_siteinformation_maintenance' 
                    content={lang.job_siteinformation.maintenance}
                  /></th>
						</tr>
					</thead>
					<tbody>
						{Element}
					</tbody>
				</Table>
				<div className="row m-top-15">
			    <div className="col-md-12 text-center">
			      {this.renderLoadMoreButton()}
			    </div>
		    </div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/App/topmenu/job/helper/component/table/AssetList.js